Monitoring.Models.SocialContents ||= {}

class Monitoring.Models.SocialContents.GnipTwitterContentFactory

  create: (socialContent, allTags) ->
    return new Monitoring.Models.SocialContents.GnipTwitterContent(socialContent).set({ possibleTags: allTags })

  canHandle: (socialContent) ->
    data = socialContent.data || socialContent
    return data.type == 'twitter' and socialContent.group_type == 'gnip'
